module.exports = __webpack_public_path__ + "static/1-025b8291c27b46479ca9a5230230eb2e.jpg";